export default {
    prodSga2subCategories: [],
    productSga2HazardClasses: []
};
